import { EBundlesInternalViewModel } from 'utils/enums';
import closeIcon from 'assets/Deca/close-icon.png';
import { BundlePrice } from 'components/BundlePrice';
import { Gradient, Prices, ProductData, Trait } from 'utils/types';
import { MainProduct } from 'templates/Bundles/Deca/MainProduct';
import { Modal } from '@mui/material';
import './styles.scss';

const DecaTooltip = ({
  prices,
  buttonTextColor,
  buttonColor,
  inMobileMock,
  setIsTooltipOpen,
  product = '',
  traits = [],
  backgroundSrc = '',
  backgroundColor,
  tooltipDescription = '',
  subProducts = [],
  isTooltipOpen = false,
  productName = '',
  setIsFocused,
  buttonText,
  isFree,
  offerName,
  classDescription,
}: {
  prices: Prices;
  buttonTextColor?: string;
  buttonColor?: Gradient;
  inMobileMock?: boolean;
  setIsTooltipOpen: (isOpen: boolean) => void;
  product?: string;
  traits?: Trait;
  backgroundSrc?: string;
  backgroundColor: Gradient;
  tooltipDescription?: string;
  subProducts?: ProductData[];
  isTooltipOpen?: boolean;
  productName?: string;
  buttonText?: string;
  isFree?: boolean;
  setIsFocused?: (isFocused: boolean) => void;
  offerName?: string;
  classDescription?: string;
}) => {
  const handleClose = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setIsTooltipOpen(false);
    setIsFocused?.(false);
  };

  const traitsText = traits
    .slice(0, -1)
    .map((trait) => trait.text)
    .join('; ');

  const apoc = traits[traits.length - 1]?.text || '';

  return (
    <Modal
      onClose={handleClose}
      open={isTooltipOpen}
      className="deca-tooltip-modal"
    >
      <div className="modal-wrapper">
        <div className="container" onClick={(e) => e.stopPropagation()}>
          <img
            onClick={handleClose}
            src={closeIcon}
            alt="close"
            className="close-icon"
          />
          <div className="title">{offerName}</div>
          <div className="description">
            <div className="description-scroll">
              <div className="header">
                <MainProduct
                  product={product}
                  traits={traits}
                  backgroundSrc={backgroundSrc}
                  backgroundColor={backgroundColor}
                />
                <div className="header-description">
                  <div className="product-name">{productName}</div>
                  {classDescription && (
                    <div className="product-description">
                      {classDescription}
                    </div>
                  )}
                  {traitsText && (
                    <div className="product-traitsText">{traitsText}</div>
                  )}
                  {apoc && <div className="product-apoc">{apoc}</div>}
                </div>
              </div>
              <div className="footer">
                {tooltipDescription && (
                  <div className="footer-description">{tooltipDescription}</div>
                )}
                {subProducts.length > 0 && (
                  <div className="footer-subProducts">
                    {subProducts.map(
                      (
                        {
                          textFontColorHex,
                          quantityDisplay,
                          images,
                          name,
                          displayName,
                        },
                        index,
                      ) => (
                        <div
                          key={index}
                          className="subProduct"
                          style={{ color: textFontColorHex }}
                        >
                          <img
                            className="subProduct-image"
                            src={images?.product}
                            alt="subProduct"
                          />
                          {quantityDisplay} {displayName ? displayName : name}
                        </div>
                      ),
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="priceContainer">
          <BundlePrice
            onClick={() => {
              setIsTooltipOpen(false);
              setIsFocused?.(false);
            }}
            prices={prices}
            buttonTextColor={buttonTextColor}
            type={EBundlesInternalViewModel.DECA}
            buttonColor={buttonColor}
            borderRadius="7px"
            isPreview={inMobileMock}
            isTextAutoResized
            buttonText={buttonText}
            isFree={isFree}
          />
        </div>
      </div>
    </Modal>
  );
};

export default DecaTooltip;
